/**
 * Wat een keuring met de puntencache van de kaart doet (MA-34).
 *
 * Eén woning kreeg een nieuw oordeel en de kaart hoort dat meteen te tonen.
 * Hoort hij nog bij het filter van deze weergave, dan springt zijn stand om en
 * blijft het punt staan. Hoort hij er niet meer bij - afgekeurd in een weergave
 * zonder filter op afgekeurd, of een kansje dat op het Kansjes-scherm iets
 * anders werd - dan gaat het punt eruit, zonder op de volgende lading te
 * wachten. Zuiver, zodat het zonder kaart te testen is.
 */
import { type Beoordeling, toontBeoordeling } from '@mamimap/shared';
import type { ServerFilter } from '../filter-url';
import type { KaartFeature } from './schemas';

/** De puntencache zoals `useGeojson` hem achterlaat. */
export type PuntenCache = {
  type: 'FeatureCollection';
  features: KaartFeature[];
  overgeslagen: number;
};

export function werkPuntenBij(
  oud: PuntenCache | undefined,
  filter: Pick<ServerFilter, 'beoordelingen'>,
  woning: { id: string; beoordeling: Beoordeling },
): PuntenCache | undefined {
  if (!oud) return oud;
  const punt = oud.features.find((feature) => feature.properties.id === woning.id);
  // Staat hij niet in deze weergave, dan is er niets te doen - en hoort de cache
  // ook hetzelfde object te blijven, anders tekent elke kaart opnieuw.
  if (!punt) return oud;

  if (!toontBeoordeling(filter.beoordelingen, woning.beoordeling)) {
    return { ...oud, features: oud.features.filter((feature) => feature !== punt) };
  }
  if (punt.properties.beoordeling === woning.beoordeling) return oud;
  return {
    ...oud,
    features: oud.features.map((feature) =>
      feature === punt
        ? { ...feature, properties: { ...feature.properties, beoordeling: woning.beoordeling } }
        : feature,
    ),
  };
}
